import React from "react";
const IconSkinCoach = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeLinejoin="bevel"
      strokeWidth="2"
      d="M5 17c0-.667 1.492-2 3.333-2h3.334c1.84 0 3.333.667 3.333 2M10 6.5a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z"
    />
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M3 11.5c0 1-.5 1.5-1 1.5.5 0 1 .5 1 1.5 0-1 .5-1.5 1-1.5-.5 0-1-.5-1-1.5ZM17 6c0 1-.5 1.5-1 1.5.5 0 1 .5 1 1.5 0-1 .5-1.5 1-1.5-.5 0-1-.5-1-1.5Z"
    />
  </svg>
);
export default IconSkinCoach;
